import { useDispatch } from 'react-redux'
import { Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ReplayIcon from '@mui/icons-material/Replay'
import { isNotEmpty, objNotEmpty } from '../../utils/helpers'
import UseTranslation from '../../hooks/UseTranslation'

const ActiveFilters = ({
  store,
  actionToDispatch,
  customStyle,
  actionProps,
}) => {
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const removeFilterHandler = (value) => {
    if (objNotEmpty(actionProps)) {
      dispatch(actionToDispatch({ queries: { filterBy: value, ...actionProps } }))
    } else {
      dispatch(actionToDispatch({ queries: value }))
    }
  }
  if (!isNotEmpty(store.activeFilters)) {
    return null
  }

  return (
    <Box sx={[styles.activeFilterContainer, customStyle && customStyle]}>
      <Box sx={styles.filters}>
        {store.activeFilters?.map((singleFilter) => (
          <Box
            key={singleFilter.id}
            sx={styles.singleFilter}
            onClick={() => removeFilterHandler(singleFilter)}
          >
            {singleFilter.name}
            <CloseIcon />
          </Box>
        ))}
      </Box>
      <Box>
        {isNotEmpty(store.activeFilters) && (
          <Box sx={styles.clearAllBtn} onClick={() => removeFilterHandler('clear')}>
            <ReplayIcon />
            {' '}
           {`${t?.['Clear Filters']}`}
          </Box>
        )}
      </Box>
    </Box>
  )
}
const styles = {
  activeFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: { xs: '10px', sm: '10px' },
    marginTop: { xs: '5px', sm: '0px' },
    overflowX: { xs: 'auto', sm: 'none' },
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&-ms-overflow-style:': {
      display: 'none',
    },
  },
  filters: {
    display: 'flex',
    alignItems: 'center',
  },
  singleFilter: {
    display: 'flex',
    alignItems: 'center',
    marginRight: { xs: '10px', sm: '20px' },
    backgroundColor: '#edfff8',
    color: 'primary.main',
    border: '1px solid #94e5c5',
    padding: { xs: '2px 7px', sm: '5px 10px' },
    borderRadius: '15px',
    cursor: 'pointer',
    fontSize: { xs: '10px', sm: '12px', md: '14px' },
    fontFamily: 'Avenir',
    width: 'max-content',
    marginBottom: { xs: '5px', sm: 'unset' },

    '& svg': {
      fontSize: { xs: '10px', sm: '14px' },
      marginBottom: '-4px',
      marginInlineStart: '10px',
    },
  },
  clearAllBtn: {
    display: { xs: 'none', sm: 'flex' },
    alignItems: 'center',
    cursor: 'pointer',
    color: '#92929D',
    fontSize: { xs: '13px', sm: '15px', md: '18px' },
    fontFamily: 'Avenir',
    textTransform: 'capitalize',
    width: 'max-content',

    '& svg': {
      fontSize: { xs: '14px', sm: '16px', md: '20px' },
      marginLeft: '10px',
    },
  },
}
export default ActiveFilters
